import { addAsset } from './utilities';

// ===============================================================
// NEWSLETTER POPUP
// ===============================================================
export const NewsletterComponent = {
  root: document.querySelector('#component-popup-newsletter-root'),
  settings: window.popupNewsletterSettings || false,
  loaded: false,

  setPopupNewsletter: function () {
    const { settings, root } = NewsletterComponent;

    // Define propriedades do componente
    let maxWidth = settings.maxWidth;
    let subdomain = settings.subdomain;
    let imageUrl = settings.imageUrl;
    let upperTitle = settings.upperTitle;
    let title = settings.title;
    let description = settings.description;
    let secondaryDescription = settings.secondaryDescription;
    let successTitle = settings.successTitle;
    let successSubtitle = settings.successSubtitle;
    let successDescription = settings.successDescription;
    let coupon = settings.coupon;

    // Inicia o componente
    const componentNewsletterPopup = new Vnda.Component.NewsletterPopup({
      maxWidth: maxWidth,
      maxHeight: 500,
      imageUrl: imageUrl,
      imagePosition: 'left',
      popupPosition: 'center',
      upperTitle: upperTitle,
      title: title,
      description: description,
      secondaryDescription: secondaryDescription,
      successTitle: successTitle,
      successSubtitle: successSubtitle,
      successDescription: successDescription,
      coupon: coupon,
      textBtnSubmit: 'Enviar',
      classBtnSubmit: 'button-newsletter',
      formKey: `${subdomain}-newsletter`,
      hasNameField: false,
      hasLastNameField: false,
      hasDateOfBirthField: false,
      hasPhoneField: false,
      delay: 500,
      frequency: '7',
      language: 'pt-BR',
      placeholders: {
        // firstName: 'Nome',
        // lastName: 'Sobrenome',
        // phone: 'Telefone',
        email: 'Digite seu e-mail',
      },
    });

    // Renderiza o componente e marca como carregado
    componentNewsletterPopup.render(root);
    NewsletterComponent.loaded = true;
  },

  loadPopupNewsletter: function () {
    if (!NewsletterComponent.loaded) {
      const { settings } = NewsletterComponent;
      addAsset(settings.script, NewsletterComponent.setPopupNewsletter);
      addAsset(settings.styles);
    }
  },

  init: function () {
    const { root, settings } = this;

    if (!root || !settings) return;

    const eventType = window.innerWidth <= 1024 ? 'scroll' : 'mousemove';
    window.addEventListener(
      eventType,
      () => {
        NewsletterComponent.loadPopupNewsletter();
      },
      { once: true }
    );
  },
};
